import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import styles from './formTitle.module.scss'

const FormTitle = (props) => {
  const { content, position, expand, ...rest } = props
  return (
    <div
      className={classNames(styles.title, styles[position])}
      style={{ flexGrow: expand || 'inherit' }}
      {...rest}
    >
      <span>{content}</span>
    </div>
  )
}

FormTitle.propTypes = {
  content: PropTypes.string.isRequired,
  expand: PropTypes.number,
  position: PropTypes.string
}

export default FormTitle
